const enum ServeType {
  DEFAULT = 'DEFAULT',
  DINE_IN = 'DINE_IN',
  TAKE_OUT = 'TAKE_OUT',
  SCHEDULE_TAKE_OUT = 'SCHEDULE_TAKE_OUT',
  DELIVERY = 'DELIVERY',
}

export default ServeType;
